"use strict";

(function () {
  'use strict';

  angular.module('lr.Devices').factory('DeviceActions', ['$http', '$q', 'api', 'User', '$lrNotifier', function ($http, $q, api, User, $lrNotifier) {
    var Command = {};
    /**
     *
     * @type {{action: string}}
     */

    Command.DEFAULTS = {
      actionURL: '/command'
    }; //todo: move to utils

    function lowerFirstLetter(string) {
      return string.charAt(0).toLowerCase() + string.slice(1);
    }
    /**
     *
     * @param bodyType
     * @param bodyVariables
     * @param device
     * @returns {{}}
     */


    Command.createPacket = function (bodyType, bodyVariables, device) {
      var packet = {};

      if (bodyType === 'application/json') {
        if (typeof bodyVariables === 'string') {
          bodyVariables = bodyVariables.split(',');
        }

        for (var i = 0; i < bodyVariables.length; i++) {
          var prop = lowerFirstLetter(bodyVariables[i]);

          if (prop === 'sessionToken') {
            packet[prop] = User.getPointCentralToken().sessionToken;
          } else {
            packet[prop] = device[prop];
          }
        }
      }

      return packet;
    };

    Command.cache = {};
    /**
     * Add a new command to the command manager
     * @param name
     * @param action
     */

    Command.addCommand = function (name, action) {
      var _this = this;

      _this.manager[name] = action;
    };
    /**
     * remove a command from the command Manager
     * @param name
     */


    Command.removeCommand = function (name) {
      var _this = this;

      delete _this.manager[name];
    };
    /**
     *
     * @type {{POST: Function, GET: Function}}
     */


    Command.manager = {
      /**
       *
       * @param url
       * @param data
       * @param tryAgain bool
       * @returns {*}
       * @constructor
       */
      POST: function POST(url, data, tryAgain) {
        console.log('Post to: ' + url + ' data: ' + data);
        var deferred = $q.defer();
        Command.cache.data = data;
        Command.cache.url = url;
        $http.post(api.proxy + Command.DEFAULTS.actionURL + url, data).success(function (data) {
          deferred.resolve(data);
          $lrNotifier.content('Success!').show();
          Command.paramsCache = {};
        }).error(function (data, status) {
          if (status === 503 && tryAgain || data.status === 401) {
            //todo: attempt to refresh token from point central
            //todo: on refresh token success execute previous command, with tryAgain set to false,
            //todo: and then we reject/resolve our old promise the old promise
            //todo: then set the command cache to empty
            console.log('command error');
          } else {
            deferred.reject(data);
            $lrNotifier.content('Failed!').show();
          }
        });
        return deferred.promise;
      },

      /**
       *
       * @param url
       * @returns {promise}
       */
      GET: function GET(url) {
        var deferred = $q.defer();
        $http.get(api.proxy + Command.DEFAULTS.actionURL + url).then(function (data) {
          deferred.resolve(data);
        }, function (data) {
          deferred.reject(data);
        });
        return deferred.promise;
      }
    };
    /**
     * Execute a command from the command manager
     * @param name
     * @returns {*}
     */

    Command.execute = function (name) {
      var _this = this;

      Command.cache.command = _this.manager[name];
      return _this.manager[name] && _this.manager[name].apply(_this.manager, [].slice.call(arguments, 1));
    };

    return Command;
  }]);
})();